module.exports = __webpack_public_path__ + "img/hover_icon_manejo_de_referidos_seguimiento.c4d2dae9.svg";